import React from 'react'
import { useLanguageContext } from '../../contexts/LanguageContext'
import './Solutions.css'
import SEO from '../seo/SEO'

const Solutions: React.FC = () => {
  const { content } = useLanguageContext()

  return (
    <>
      <SEO 
        title={content.solutions.seo.title} 
        description={content.solutions.seo.description} 
      />
      <section id="solutions" className="solutions-section">
        <div className="container">
          <div className="solutions-header text-center">
            <p className="section-subtitle">{content.solutions.subtitle}</p>
            <h2 className="section-title">{content.solutions.title}</h2>
            <p className="section-description">{content.solutions.description}</p>
          </div>

          <div className="solutions-grid">
            {content.solutions.apps.map((app: any, index: number) => (
              <div key={index} className="solution-card card">
                <img className='solution-icon' src={app.image}/>
                <h3 className="solution-title">{app.title}</h3>
                <p className="solution-description">{app.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}

export default Solutions